var SCM = SCM || {};

SCM.DynamicDiscovery = (function (SCM) {
    const tooltips = document.getElementsByClassName('js-navbar-ai-assistant-tooltip');
    var discoveryMode = null;

    return {
        init: init
    };

    function init() {
        listenForSignInDialog();

        discoveryMode = getDiscoveryModeFromPage();

        if (discoveryMode != null && !localStorage.getItem(`dynamic-${discoveryMode}-first-time-session`)) {
            toggleFirstTimeSession();
        }
    }

    function toggleFirstTimeSession() {
        if (!tooltips.length && discoveryMode == null)
            return;

        localStorage.setItem(`dynamic-${discoveryMode}-first-time-session`, '1');

        for (let tooltip of tooltips) {
            tooltip.classList.remove('hidden');
            tooltip.addEventListener('click', (e) => { e.stopPropagation(); });
        }

        document.addEventListener('click', hideTooltipThenRemoveListener);
    }

    function hideTooltipThenRemoveListener() {
        for (let tooltip of tooltips) {
            tooltip.classList.add('hidden');
        }

        document.removeEventListener('click', hideTooltipThenRemoveListener);
    }

    function listenForSignInDialog() {
        let assistantLinks = document.getElementsByClassName('js-navbar-ai-assistant-link');

        for (let assistantLink of assistantLinks) {
            assistantLink.addEventListener('click', openSignInDialog);
        }
    }

    function openSignInDialog() {
        let assistantLinks = document.getElementsByClassName('js-navbar-ai-assistant-link');

        for (let assistantLink of assistantLinks) {
            assistantLink.removeEventListener('click', openSignInDialog);
        }

        let subdomain = App.CurrentSubdomain;
        let ajaxUrl = subdomain === '' ? '/Ai/DynamicDiscoverySignIn' : `/${subdomain}/Ai/DynamicDiscoverySignIn`;
        let modalErrorMessage = 'An error occurred while trying to open the sign in dialog.';

        SCM.Ajax.get(ajaxUrl, null)
            .expectHtml()
            .then(function (result) {
                SCM.Modals.showModal(result);
            })
            .catch(function (reason) {
                console.error(reason);
                SCM.Modals.showModal(modalErrorMessage);
            });

        listenForDialogClose();
    }

    function listenForDialogClose() {
        $body.on('click', '.js-close-modal', _removeModalBg);
        $body.on('click', '.js-modal-overlay', _removeModalBg);
    }

    // The actual modal close is handled by SCM.Modals.js but the background stays up
    function _removeModalBg() {
        $body.off('click', '.js-close-modal', _removeModalBg);
        $body.off('click', '.js-modal-overlay', _removeModalBg);

        let modalBgs = document.getElementsByClassName('reveal-modal-bg');

        for (let modalBg of modalBgs) {
            modalBg.remove();
        }

        listenForSignInDialog();
    }

    function getDiscoveryModeFromPage() {

        if (tooltips?.length > 0) {
            return tooltips[0]?.getAttribute('data-discoverymode');
        }
        else if (document.getElementsByClassName('js-dynamic-discovery-page').length > 0) {
            return "discovery";
        }

        return null;
    }

})(SCM);
